export default __webpack_public_path__ + "static/media/heading-membership.a787ccdf.png";